import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Sidebar.module.css';

const MIN_WIDTH_RESIZE = 400;
const MAX_WIDTH_RESIZE = 800;
const bindClasses = classNameBind.bind(styles);

class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.startXPosition = null;
    this.startWidth = null;
    this.wrapper = null;
    this.resizeHandler = null;
    this.currentWidth = null;
  }

  initResize = (e) => {
    e.preventDefault();
    this.startXPosition = e.clientX;
    this.startWidth = parseInt(document.defaultView.getComputedStyle(this.wrapper).width, 10);
    this.resizeHandler.className = bindClasses('resize-handler', '-active');
    this.wrapper.className = bindClasses('resizable', '-active');

    window.addEventListener('mousemove', this.doResize, false);
    window.addEventListener('mouseup', this.stopResize, false);
  }

  doResize = (e) => {
    const { onResize } = this.props;
    e.preventDefault();
    this.currentWidth = this.startWidth + e.clientX - this.startXPosition;
    if (this.currentWidth >= MIN_WIDTH_RESIZE && this.currentWidth <= MAX_WIDTH_RESIZE) {
      this.wrapper.style.width = `${this.currentWidth}px`;
      onResize(this.currentWidth);
    }
  }

  stopResize = () => {
    this.resizeHandler.className = bindClasses('resize-handler');
    this.wrapper.className = bindClasses('resizable');
    window.removeEventListener('mousemove', this.doResize, false);
    window.removeEventListener('mouseup', this.stopResize, false);
  }

  render() {
    const { children, resizable, initSize, styled } = this.props;

    return (
      <div
        className={bindClasses('wrapper')}
        data-ppuc-id="Sidebar"
      >
        {resizable
          && (
            <div
              ref={(handler) => { this.resizeHandler = handler; }}
              onMouseDown={e => this.initResize(e)}
              className={bindClasses('resize-handler')}
              data-ppuc-id="Sidebar.resize"
              role="button"
              tabIndex={0}
            >
              <div className={bindClasses('resize-line')} />
            </div>
          )
        }
        <div
          ref={(handler) => { this.wrapper = handler; }}
          className={bindClasses(resizable ? 'resizable' : 'fixed-width', { styled })}
          style={resizable && initSize ? { width: `${initSize}px` } : {}}
          data-ppuc-id="Sidebar.value"
        >
          {children}
        </div>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  children: null,
  resizable: false,
  initSize: null,
  onResize: () => {},
};

export default Sidebar;
